<template>
  <div>
    <div class="register">
      <p class="PRegisterTitle">
        <span><router-link to="/login"><img src="../../assets/images/users/Return.png"></router-link></span>
        <span>新規登録</span>
        <span></span>
      </p>
      <p class="RegisterTitle">新規登録</p>
      <div class="register_input regist_one">
        <input name="reg_mail" v-model="reg_email" type="text" placeholder="メールアドレス">
        <span v-show="errors.has('reg_email')" class="error">{{ errors.first('reg_email') }}</span>
      </div>
      <div class="register_yan">
        <input type="text" name="reg_code" v-model="reg_code" placeholder="検証コード">
        <countInfo class="code_num" :start='start' @countDown='start=false' @click.native='gainCode'></countInfo>
        <span v-show="errors.has('reg_code')" class="error">{{ errors.first('reg_code') }}</span>
      </div>
      <div class="register_input">
        <input placeholder="携帯電話番号:  eg:07012345678" name="reg_tel" v-model="reg_tel" type="text">
        <span v-show="errors.has('reg_tel')" class="error">{{ errors.first('reg_tel') }}</span>
      </div>
      <div class="register_input">
        <input name="reg_name" v-model="reg_name" type="text" placeholder="ユーザID:アルファベット6~16文字で構成されている。">
        <span v-show="errors.has('reg_name')" class="error">{{ errors.first('reg_name') }}</span>
        <!--<p> 6-20位英文文字、小文字を区分しない。</p>-->
      </div>
      <div class="register_input">
        <input name="reg_pwd" v-model="reg_pwd" type="password" placeholder="パスワード:6~16文字のアルファベットと数字。">
        <span v-show="errors.has('reg_pwd')" class="error">{{ errors.first('reg_pwd') }}</span>
        <!--<p>6~16文字のアルファベットと数字。</p>-->
      </div>
      <div class="register_input">
        <input name="reg_conpwd" v-model="reg_conpwd" type="password" placeholder="パスワード確認">
        <span v-show="errors.has('reg_conpwd')" class="error">{{ errors.first('reg_conpwd') }}</span>
        <span class="error">{{errorMessage}}</span>
      </div>
      <p class="zhengce">個人情報保護方針に同意してログイン</p>
      <div class="register_home">
        <button @click="tohome">登録して</button>
      </div>
      <p class="tologin">
        <router-link to="/login">
          <span class="Glogin">ログイン</span><span class="jiantou"></span></router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import countInfo from '../common/countInfo.vue';
  import {register, vertifyCode} from './../../api/interface/users'
  import VeeValidate, {Validator} from 'vee-validate'
  import cn from 'vee-validate/dist/locale/zh_CN'
  Validator.localize('cn', cn);
  const dict = {
    cn: {messages: {required: (name) => `${name}必要!`}}
  };
  Validator.localize(dict);
  export default{
    name: "",
    validator: null,
    start: false,
    data(){
      return {
        errors: null,
        start: false,
        reg_email: "",
        reg_tel: "",
        reg_name: "",
        reg_pwd: "",
        reg_conpwd: "",
        reg_code: "",
        errorMessage: ""
      }
    },
    methods: {
      gainCode(){
        this.validator.validateAll({
          reg_email: this.reg_email,
        }).then(result => {
          if (result) {
            let email_info = {
              email: this.reg_email,
            };
            vertifyCode(email_info).then(result => {
              this.$message({
                message: '発送完了',
                type: 'success'
              });
              console.log("===========");
              console.log(result);
              localStorage.setItem('authMd5Data', result.message.authMd5Data)
              localStorage.setItem('salt', result.message.salt)
            }).catch(err => {
              if (err.code == 17) {
                this.errorMessage = err.message
              }
            });
            this.start = true
          }
        })
      },
      tohome () {
        this.$router.push({path: "/404"})
      },
    },
    components: {
      countInfo
    },
    created(){
      this.validator = new Validator({});  // 初始化Validator对象
      Validator.extend('reg_email', {
        getMessage: field => '正しいメールアドレスを入力してください',
        validate: value => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)  // 验证条件
      });
      Validator.extend('reg_tel', {
        getMessage: field => "正しい携帯番号を入力してください",
        validate: value => value.length === 11 && /^(070|080|090)[0-9]{8}/.test(value)  // 验证条件
      });
      Validator.extend('reg_name', {
        getMessage: field => 'ユーザIDの入力に誤りがあります',
        validate: value => /^[A-Za-z]{6,16}/.test(value)  // 验证条件
      });
      Validator.extend('reg_pwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /[0-9a-zA-Z]{6,16}/.test(value)  // 验证条件
      });
      Validator.extend('reg_conpwd', {
        getMessage: field => 'パスワードが一致しません',
        validate: value => this.reg_pwd === this.reg_conpwd // 验证条件
      });
      this.validator.attach({name: 'reg_email', rules: 'required|reg_email|', alias: 'メールアドレス'});
      this.validator.attach({name: 'reg_tel', rules: 'required|reg_tel|decimal', alias: 'お電話番号'});
      this.validator.attach({name: 'reg_name', rules: 'required|reg_name|', alias: 'ユーザID'});
      this.validator.attach({name: 'reg_pwd', rules: 'required|reg_pwd|', alias: 'パスワード'});
      this.validator.attach({name: 'reg_conpwd', rules: 'required|reg_conpwd|', alias: 'パスワード確認'});
      this.validator.attach({name: 'reg_code', rules: 'required', alias: '検証コード'});
      this.$set(this, 'errors', this.validator.errors);
    },
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: 0px) and(max-width: 749px) {
    .register {
      width: 100%;
      .PRegisterTitle {
        height: 50px;
        line-height: 50px;
        background-color: $TitColor;
        width: 100%;
        color: $whiteColor;
        display: flex;
        font-size: 16/$default-w+rem;
        justify-content: space-between;
        span:nth-child(1),
        span:nth-child(3) {
          height: 50px;
          width: 50px;
        }
        img {
          width: 30px;
          height: 30px;
          margin: 10px;
        }
      }
      .RegisterTitle {
        display: none;
      }
      input {
        border: none;
        outline: none;
        margin-left: 5px;
      }
      .register_input {
        width: 286px;
        height: 30px;
        background-color: white;
        margin: 0 auto;
        margin-top: 25px;
        border: 1px solid $fontColor;
        border-radius: $radio;
        input {
          height: 29px;
          width: 280px;
          border-radius: $radio;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
        p {
          /*background-color: #eba898;*/
          font-size: 12px;
        }
      }
      .register_yan {
        width: 286px;
        height: 30px;
        background-color: white;
        margin: 0 auto;
        margin-top: 25px;
        border: 1px solid $fontColor;
        border-radius: $radio;
        input {
          height: 29px;
          width: 200px;
          float: left;
        }
        .code_num {
          float: right;
          cursor: default;
          text-align: center;
          height: 30px;
          width: 81px;
          color: white;
          font-size: 14px;
          line-height: 30px;
          background-color: $fontColor;
          border-radius: $radio;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      .register_home {
        outline: none;
        height: 30px;
        width: 200px;
        letter-spacing: $letter;
        margin: 40px auto;
        button {
          width: 100%;
          height: 100%;
          border-radius: 5px;
          background-color: $fontColor;
          border: none;
          color: white;
          outline: none;
        }
      }
      .zhengce {
        width: 300px;
        height: 20px;
        text-align: center;
        margin: 0 auto;
        margin-top: 20px;
        font-size: 10px;
        line-height: 20px;
      }
      .tologin {
        display: none;
      }
      .regist_one {
        margin-top: 50px;
      }
    }
  }

  @media screen and(min-width: 750px) {
    .register {
      width: 400px;
      margin: 100px auto;
      a {
        text-decoration: none;
      }
      p {
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        img {
          margin: 0 auto;
        }
      }
      .PRegisterTitle {
        display: none;
      }
      input {
        border: none;
        outline: none;
        margin-left: 5px;
      }
      button {
        outline: none;
        height: 30px;
        width: 290px;
        background-color: $fontColor;
        border: none;
        color: white;
        letter-spacing: 4px;
      }
      .register_input {
        width: 386px;
        height: 35px;
        background-color: white;
        margin: 0 auto;
        margin-top: 30px;
        border: 1px solid $fontColor;
        border-radius: $radio;
        input {
          height: 34px;
          width: 380px;
          border-radius: $radio;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }

      }
      .register_yan {
        width: 386px;
        height: 35px;
        background-color: white;
        margin: 0 auto;
        margin-top: 30px;
        border: 1px solid $fontColor;
        border-radius: $radio;
        input {
          height: 34px;
          width: 300px;
          float: left;
        }
        .code_num {
          float: right;
          cursor: default;
          height: 35px;
          width: 81px;
          color: white;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          /*line-height: 35px;*/
          background-color: $fontColor;
          border-radius: $radio;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }

      }
      .register_home {
        margin: 40px 0 40px 55px;
        border-radius: 5px;
      }
      .zhengce {
        width: 386px;
        height: 20px;
        /*text-align: center;*/
        margin: 0 auto;
        margin-top: 20px;
        font-size: 12px;
        line-height: 20px;
      }
      .tologin {
        /*background-color: #960;*/
        .Glogin {
          float: left;
          font-size: 14px;
          margin-left: 5px;
          color: $navcolor;
        }
        .jiantou {
          float: left;
          margin-top: 2px;
          margin-left: 2px;
          position: relative;
          display: inline-block;
          height: 0px;
          width: 0px;
          border-top: 8px solid transparent;
          border-left: 16px solid $navcolor;
          border-bottom: 8px solid transparent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/users/register.vue